<template>
  <div class="editor-wrapper clearfix">
    <div id="editor-holder"></div>

    <div class="save-button-container" v-if="editor">
        <div class="success-message" v-if="successMessage" v-html="successMessage"></div>
        <button @click="saveForm" class="btn btn-primary float-end save-button" :disabled="isCurrentTenantInactive()">Save</button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
const editors = require('@/libs/values-jsoneditor.js')

export default {
  data() {
    return {
      editor: null,
      savedJson: '',
      successMessage: null,
      errorMessage: null
    }
  },
  computed: {
    ...mapGetters(['editorData', 'isAdmin', 'sectionSelected', 'currentSection', 'currentTenant', 'userTenants'])
  },
  created() {
    this.getData()
  },
  methods: {
    saveForm(event) {
      let editorValue = this.editor.getValue()

      this.savedJson = JSON.stringify(editorValue, null, 2)
      this.$store.dispatch('updateValues', editorValue).then(response => {
        this.$store.dispatch('showMessage', {
          title: 'Save',
          text: 'Changes saved successfully',
          type: 'success'
        })
      })
    },
    setValueEditor(val) {
      if (val == null || val.schema == null || val.values == null) {
        this.$store.dispatch('showMessage', {
          title: 'Save',
          text: 'No data found for tenant',
          type: 'error'
        })
        return
      }
      this.resetOutput()
      if (this.editor != null) {
        this.editor.destroy()
      }
      var schema = val.schema
      if (!schema.title && this.currentSection && this.currentSection.displayName) {
        schema = Object.assign({}, schema, { title: this.currentSection.displayName })
      }
      this.editor = new editors.JsonEditor(document.getElementById('editor-holder'), {
        schema: schema,
        ajax: true,
        no_additional_properties: true,
        startval: val.values,
        theme: 'bootstrap3',
        iconlib: 'fontawesome6',
        // disable_collapse: true,
        disable_array_add: false,
        disable_array_delete: false,
        disable_array_reorder: false,
        // disable_edit_json: !this.isAdmin,
        disable_properties: true
      })
      let errors = this.editor.validate()
      if (errors.length) {
        //TODO show errors
        console.log('errors')
      }
    },
    resetOutput() {
      this.showOutput = false
      this.savedJson = ''
    },
    getData() {
      this.$store.dispatch('getEditorData')
      this.$store.commit('clearSectionSelected')
    },
    isCurrentTenantInactive() {
      //userTenants are not being fetched for non admins
      if (!this.isAdmin) return false

      const tenantInfo = this.userTenants.find(t => t.identifier === this.currentTenant)
      return tenantInfo != null ? tenantInfo.inactive : true
    }
  },
  watch: {
    editorData(val, oldVal) {
      this.setValueEditor(val)
    },
    sectionSelected(val, oldVal) {
      if (val) this.getData()
    }
  }
}
</script>

<style scoped>
.editor-wrapper {
  margin-bottom: 20px;
  clear: both;
}
.saved-json {
  height: 700px;
  width: 700px;
}
.save-button-container {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 10px 10px;
  background-color: var(--bs-body-bg);
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
  z-index: 10;
  border-top: 1px solid var(--bs-dark-border-subtle);
}

.save-button {
  padding-inline: 40px;
}
</style>
<style>
#editor-holder > div > .card {
  background-color: var(--bs-secondary-bg);
}

#editor-holder select.form-control {
  appearance: auto;
}

#editor-holder .json-editor-modal {
  background-color: var(--bs-tertiary-bg);
  color: var(--bs-body-color);
}

#editor-holder .control-label {
  font-weight: 500;
  font-size: 14px;
}

#editor-holder h4 {
  font-weight: 400;
}

#editor-holder p {
  margin-bottom: 0.2rem;
}

#editor-holder .checkbox p {

  margin-top: 0;
  padding-left: 18px;
}

#editor-holder .btn {
  max-width: 150px;
}

#editor-holder .row {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  margin-bottom: 0.5rem;
}

#editor-holder .rows {
  display: flex;
  flex-wrap: wrap;
}

#editor-holder h3,
#editor-holder h4,
#editor-holder h5 {
  margin-top: 5px;
  margin-bottom: 5px;
}

#editor-holder h3 span,
#editor-holder h4 span,
#editor-holder h5 span {
  vertical-align: middle;
}

#editor-holder .form-group {
  margin-bottom: 5px;
}

#editor-holder textarea {
  resize: both;
}

#editor-holder .rows > .tabs {
  display: flex;
  flex-direction: column;
  padding-right: 8px;
}

/* On smaller screens tabs stack above the content full width */
@media (max-width: 767.98px) {
  #editor-holder .rows > .tabs {
    flex-direction: row;
    flex-wrap: wrap;
    padding-right: 0;
    padding-bottom: 8px;
  }

  #editor-holder .rows > .tabs .list-group-item {
    white-space: normal;
  }
}

#editor-holder .rows > .tabs .list-group-item {
  border-radius: 0;
  padding: 8px 12px;
  cursor: pointer;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-decoration: none;
}

#editor-holder .rows > .tabs .list-group-item:first-child {
  border-radius: 6px 6px 0 0;
}

#editor-holder .rows > .tabs .list-group-item:last-child {
  border-radius: 0 0 6px 6px;
}

#editor-holder .rows > .tabs .list-group-item:only-child {
  border-radius: 6px;
}

#editor-holder .rows > .tabs .list-group-item:hover {
  background-color: var(--bs-secondary-bg);
}

#editor-holder .rows > .tabs .list-group-item.active {
  background-color: var(--bs-primary);
}

#editor-holder .rows > .col-md-10,
#editor-holder .rows > .col-12.col-md-10 {
  min-width: 0;
}

/* Single button inside a btn-group should have rounded corners on all sides
 Targets a .btn with no other .btn siblings, even if other elements (divs) exist in the group */
#editor-holder .btn-group > .btn:not(.btn ~ .btn):not(:has(~ .btn)) {
  border-radius: 6px !important;
}

/* Restore right-side radius on the last visible .btn when subsequent .btn siblings are hidden */
#editor-holder .btn-group > .btn:not([style*="display: none"]):not(:has(~ .btn:not([style*="display: none"]))) {
  border-top-right-radius: 6px !important;
  border-bottom-right-radius: 6px !important;
}

/* Restore left-side radius on the first visible .btn */
#editor-holder .btn-group > .btn:not([style*="display: none"]):not(.btn:not([style*="display: none"]) ~ .btn:not([style*="display: none"])) {
  border-top-left-radius: 6px !important;
  border-bottom-left-radius: 6px !important;
}

#editor-holder .checkbox label {
  display: flex;
  flex-direction: row-reverse;
  justify-content: flex-end;
  align-items: center;
  gap: 5px;
  font-weight: normal;
  cursor: pointer;
}

#editor-holder .checkbox label input[type="checkbox"] {
  flex-shrink: 0;
  margin: 0;
  width: 1em;
  height: 1em;
}

</style>



// WEBPACK FOOTER //
// src/components/ValueEditor.vue